class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const line = this.dataset.index;

      // get cart
      const cart = await fetch('/cart.js').then(res => res.json());
      const item = cart.items[line - 1];

      // Free bundle removed by hand — flag it so cart-drawer-bundle.js stops auto-adding and shows its Add button instead.
      if (item?.properties?._bundle_gift === 'true') {
        try { sessionStorage.setItem('bundleGiftDismissed', '1'); } catch (e) {}
      }

      // check if deleting free gift. Bundle lines are excluded: they carry _gift too, so
      // without this their variant id would land in removedGiftIds - the list the OTHER
      // freebie systems read to decide a gift was refused and must never be re-added. The
      // bundle has its own flag above, so nothing is lost by keeping it out of this one.
      if (item?.properties?._gift === 'true' && item?.properties?._bundle_gift !== 'true') {

        const removedGiftIds = JSON.parse(
          sessionStorage.getItem('removedGiftIds') || '[]'
        );

        const variantId = parseInt(item.variant_id);

        // Avoid duplicates
        if (!removedGiftIds.includes(variantId)) {
          removedGiftIds.push(variantId);
          sessionStorage.setItem(
            'removedGiftIds',
            JSON.stringify(removedGiftIds)
          );
        }


      }

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(line, 0, event, null, null, true);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
    this.setupBundleButton();
  }

  setupBundleButton() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('#delete-cart-bundle')) {
        this.handleBundleDelete();
      }
    })
  }

  async handleBundleDelete() {
    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      if (!cart.items.length) {
        window.location.reload();
        return;
      }

      const updates = {};
      let bundleFound = false;

      // Loop through all cart items
      cart.items.forEach(item => {
        const hasBundleProperty = item.properties && item.properties['bundle-product'];

        // Remove only bundle products
        if (hasBundleProperty) {
          updates[item.key] = 0; // delete this bundle product
          bundleFound = true;
        }
      });

      if (!bundleFound) {
        this.showNoBundleItemsMessage?.();
        return;
      }

      // Call update API only for bundle products (don’t touch others)
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      const updatedCart = await response.json();

      // ✅ Update bubble and refresh UI
      this.updateCartBubbleCount?.(updatedCart.item_count);
      this.onCartUpdate?.();

      if (updatedCart.item_count === 0) {
        const cartItems = document.querySelector('cart-items');
        if (cartItems) cartItems.classList.add('is-empty');

        if (!window.location.href.includes('/cart')) {
          window.refreshCartDrawer();
        }
      }

    } catch (error) {
      console.error('Error removing bundle products:', error);
      this.showErrorMessage?.();
    }
  }

  // ✅ New helper method for cart bubble update
  updateCartBubbleCount(count) {
    const cartBubble = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
    const visuallyHidden = document.querySelector('.cart-count-bubble .visually-hidden');
    const bubbleWrapper = document.querySelector('.cart-count-bubble');

    cartBubble?.forEach((each) => {
      each.textContent = count;
    })

    if (visuallyHidden) visuallyHidden.textContent = `${count} items`;
  }

  showNoBundleItemsMessage() {
    alert('No bundle items found in your cart.');
  }

  showErrorMessage() {
    alert('An error occurred while trying to remove bundle items.');
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input?.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }

          // Freebie handlers are intentionally NOT called here. The single sequential
          // cartUpdate subscriber (cart.js ~1372) already runs gift/auto/rotating against a
          // fresh cart on this same event — including this add — so running them here too was
          // a redundant parallel pass (guarded only by flags) plus 3 extra /cart.js fetches.
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          // This re-render reset the "add the gift back" button to hidden — re-apply it
          // (guardless) so it isn't left hidden until a page refresh.
          window.syncCartPageGiftAtc?.();
          // Freebie handlers run via the single sequential subscriber (see note above).
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId, isDelete = false) {
    this.enableLoading(line);

    document.body.classList.add('cart-updating');

    // ==========================================
    // REMOVE PREVIOUS STYLE TAG IF EXISTS
    // ==========================================
    window._cartSpinnerStyle?.remove();

    const styleTag = document.createElement('style');
    styleTag.textContent = `
      body.cart-updating #CartItem-${line} .loading__spinner,
      body.cart-updating #CartDrawer-Item-${line} .loading__spinner {
        display: flex !important;
      }
    `;
    document.head.appendChild(styleTag);
    window._cartSpinnerStyle = styleTag;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.updateCartBubbleCount?.(parsedState.item_count);

          if (window.location.href.includes('/apps/wishlist')) {
            // If Shopify doesn't send sections (happens on app pages like /apps/wishlist)
            if (!parsedState.sections) {
  
              // Update the cart bubble count
              if (typeof this.updateCartBubbleCount === "function") {
                this.updateCartBubbleCount(parsedState.item_count);
              }
  
              // --- Keep cart drawer open & refresh it ---
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                fetch('/?section_id=cart-drawer')
                  .then(res => res.text())
                  .then(html => {
                    const dom = new DOMParser().parseFromString(html, 'text/html');
                    const newDrawer = dom.querySelector('cart-drawer');
   
                    if (newDrawer) {
                      // Replace existing drawer with updated HTML without closing it
                      const cartDrawerEle = cartDrawer.querySelector('#cartDrawer');
                      cartDrawer.innerHTML = newDrawer.innerHTML
                    }
                  })
                  .catch(err => console.error("Drawer refresh error:", err));
              }
  
              this.disableLoading(line);
              return;
            }
          }

          if (isDelete) {
            document.body.classList.remove('cart-updating');
          }

          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container) return; // section not present on this page (e.g. cart-live-region-text) — skip, don't throw
            const elementToReplace = container.querySelector(section.selector) || container;
            const newHtml = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            if (newHtml != null) elementToReplace.innerHTML = newHtml;
          });

          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);

        // Freebie handlers run once, via the cartUpdate subscriber below (with a freshly
        // fetched cart). Calling them directly here too caused a double invocation: the
        // subscriber's no-op cycle hid the loader while the direct removal was still in
        // flight, so a threshold-down freebie removal looked like a second loading phase.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        // The error container isn't present on every layout — guard against null.
        if (errors) errors.textContent = (window.cartStrings && window.cartStrings.error) || '';
      })
      .finally(() => {
        this.disableLoading(line);
        // Per-line loader cleanup: drop the "updating" state + its style tag so the
        // line spinner clears once this item's update has rendered.
        document.body.classList.remove('cart-updating');
        window._cartSpinnerStyle?.remove();
        window._cartSpinnerStyle = null;
        // NOTE: the freebie handlers are intentionally NOT called here. They run once via
        // the cartUpdate subscriber (published above) — serialized, with a fresh cart
        // between each — so gifts add/remove reliably. Calling them here too caused
        // duplicate, parallel runs whose refreshes raced and left a gift half-removed.
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      const errText = lineItemError.querySelector('.cart-item__error-text');
      if (errText) errText.textContent = message;
    }

    this.lineItemStatusElement?.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return; // not present on every layout — skip rather than throw
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    // [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Sticky checkout button for mobile Device
window.addEventListener('scroll', function() {
  var scrollableDiv = document.querySelector('.cart-items');
  var targetDiv = document.getElementById('cartCheckoutButton');

  if (scrollableDiv && targetDiv) {
    // Get the scroll position and the height of the scrollable div
    var scrollPosition = window.scrollY;
    var scrollableHeight = (scrollableDiv.offsetHeight);
    
    // Example: Add the class when scrolled past 50% of the scrollable height
    if (scrollPosition < (scrollableHeight) || scrollPosition > (scrollableHeight + 500) ) {
      targetDiv.classList.add('sticky-checkout');
    } else {
      targetDiv.classList.remove('sticky-checkout');
    }
  }
});


// Free gift code 
window.refreshCart = function () {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return Promise.resolve();

  const sections = cartItems.getSectionsToRender();
  const sectionIds = sections.map(section => section.section).join(',');
  const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}`;

  return Promise.all([
    fetch('/cart.js').then(res => res.json()),
    fetch(sectionsUrl).then(res => res.json())
  ])
    .then(([cartState, parsedSections]) => {
      const cartEmpty = cartState.item_count === 0;

      sections.forEach(section => {
        const elementToReplace =
          document.getElementById(section.id)?.querySelector(section.selector) ||
          document.getElementById(section.id);

        if (!elementToReplace || !parsedSections[section.section]) return;

        const html = new DOMParser().parseFromString(
          parsedSections[section.section],
          'text/html'
        );

        const inner = html.querySelector(section.selector);
        if (inner) {
          elementToReplace.innerHTML = inner.innerHTML;
        }
      });

      /* ✅ EMPTY CART HANDLING */
      if (cartEmpty) {
        emptyCart(); // your existing function
      }

      /* ✅ RE-RUN CART LOGIC */
      if (typeof window.handleGiftProduct === 'function') {
        window.handleGiftProduct(cartState);
      }

      if (typeof window.handleAutoProduct === 'function') {
        window.handleAutoProduct(cartState);
      }

      // Repaint the free bundle picker (the cart page renders it too). No second argument,
      // so this paints and nothing else - adding or removing here would run concurrently
      // with the two handlers above, which are working from the cartState fetched earlier.
      // Handed the cartState fetched at the top of this function, so the picker paints from exactly the cart these sections were rendered from instead of spending another round trip re-reading it.
      window.syncCartDrawerBundle?.(cartState);

      // Keep every cart-count bubble (header + sticky nav) in sync after a freebie change.
      window.updateCartCountBubbles?.(cartState.item_count);

      // Restore the "add the gift back" button after the section re-render above reset it to
      // hidden — guardless, so handleGiftProduct's in-progress lock can't skip it.
      window.syncCartPageGiftAtc?.();

      document.body.classList.remove('cart-updating');
      window.setFreebieLoading?.(false);
    })
    .catch(e => {
      console.error('Cart refresh failed', e);
      window.setFreebieLoading?.(false);
    });
};

// Re-apply the cart-page "add the gift back" button (.free-gift-addtocart) visibility.
// Liquid renders that button hidden; it should be visible for a gift the shopper MANUALLY
// removed while its threshold is still met — the exact rule handleGiftProduct uses. Every
// cart section re-render resets it to hidden, and handleGiftProduct's un-hide can be skipped
// by its in-progress guard, so this guardless, idempotent helper restores it after re-renders.
window.syncCartPageGiftAtc = function () {
  const bar = document.getElementById('free-gift-bar');
  if (!bar) return; // cart page only (the drawer uses .cd-gift-strip)
  let removed = [];
  let configs = [];
  try { removed = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]'); } catch (e) {}
  try { configs = JSON.parse(bar.dataset.giftConfigs || '[]'); } catch (e) {}
  const anyRemoved = configs.some((c) => removed.includes(parseInt(c.variantId)));
  if (!anyRemoved) return;
  document.querySelectorAll('.free-gift-addtocart').forEach((el) => el.classList.remove('hidden'));
};


window.refreshCartDrawer = function () {
  // During a "Buy Now" redirect we still want the gift line items added/removed, but
  // NOT the drawer re-rendered and opened (renderContents calls open()), which would
  // flash the drawer open just before the checkout redirect. Skip the render entirely.
  if (window._suppressCartDrawerOpen) return Promise.resolve();

  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return Promise.resolve();

  const sections = cartDrawer.getSectionsToRender();
  const sectionIds = sections.map((section) => section.id).join(',');

  let cartDrawerEmpty = false
  let cartCount = null;
  // Cart JSON fetched ALONGSIDE the sections, not after them: the bundle-picker repaint below needs a cart, and letting it fetch its own added a serial round trip to every drawer refresh - in parallel it costs no extra wall clock, and resolves to null on failure so the picker can still fall back to fetching its own.
  return Promise.all([
    fetch(`${routes.cart_url}?sections=${sectionIds}`).then((res) => res.json()),
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .catch(() => null),
  ])
    .then(([parsedState, cartState]) => {
      sections.forEach((section) => {
        const sectionHTML = parsedState[section.id];
        const htmlDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const freshDrawer = htmlDoc.querySelector('cart-drawer');
        const cartDrawerItems = freshDrawer?.getAttribute('data-cart-count');
        if (cartDrawerItems != null) cartCount = cartDrawerItems;

        // Carry the freshly rendered count/total onto the live element. Only the sections
        // inside it are replaced, so without this its data-cart-* would keep the values it
        // was first rendered with - and CartDrawer.refreshIfStale, which compares them
        // against the server on open, would re-render on every open after any cart change.
        const freshTotal = freshDrawer?.getAttribute('data-cart-total');
        if (cartDrawerItems != null) cartDrawer.setAttribute('data-cart-count', cartDrawerItems);
        if (freshTotal != null) cartDrawer.setAttribute('data-cart-total', freshTotal);
        if (cartDrawerItems && cartDrawerItems == '0' || cartDrawerItems == 0) {
          cartDrawerEmpty = true
        }
      });

      // If cart drawer empty adding is-empty class to cart drawer
      if (cartDrawerEmpty) {
        emptyCart();
      }

      // Silent refresh (openDrawer=false): update drawer contents in place without opening it; prevents the drawer auto-opening on page load during freebie/gift sync. Add-to-cart still opens via product-form.js (default openDrawer=true).
      cartDrawer.renderContents({
        id: null, // or use product ID if available
        sections: parsedState
      }, false);

      // Keep every cart-count bubble in sync (header + mobile sticky nav). The nav isn't
      // part of the re-rendered sections, so a freebie add/remove wouldn't update it otherwise.
      if (cartCount != null) window.updateCartCountBubbles?.(cartCount);

      // Re-evaluate the "add the free gift back" strip against the fresh cart.
      window.updateCartDrawerGiftStrips?.();

      // Same for the free bundle picker — its Liquid renders hidden, so it needs a repaint after each re-render.
      // Handed the cart fetched in parallel above, so this paints without a round trip of its own.
      window.syncCartDrawerBundle?.(cartState);

      window.setFreebieLoading?.(false);
    })
    .catch((e) => {
      console.error('Cart drawer refresh failed', e);
      window.setFreebieLoading?.(false);
    });
};

function emptyCart() {
  const cartDrawerWrapper = document.querySelector('cart-drawer');
  const cartFooter = document.querySelector('.main-cart__wrapper');
  if (cartFooter) cartFooter.classList.add('is-empty');
  if (cartDrawerWrapper) cartDrawerWrapper.classList.add('is-empty');
}


// ==========================================
// FREE GIFT LOGIC
// ==========================================

window.isGiftProductUpdating = false;
window._giftAddInProgress = false;

// Update every cart-count bubble on the page (header + mobile sticky nav) to `count`.
// Used to keep the count in sync after cart changes that happen outside the normal
// add-to-cart flow — e.g. a freebie added/removed by the reward-threshold handlers,
// whose refresh only re-renders the drawer sections, not the sticky nav.
window.updateCartCountBubbles = function (count) {
  const n = parseInt(count, 10);
  if (Number.isNaN(n)) return;
  document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
    el.textContent = n;
  });
  document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach((el) => {
    el.textContent = `${n} items`;
  });
};

// Overlay + spinner shown on the cart drawer while a freebie is being added/removed.
// The class lives on the persistent <cart-drawer> element so it survives re-render.
window.setFreebieLoading = function (on) {
  document.querySelector('cart-drawer')?.classList.toggle('is-freebie-loading', !!on);
  document.querySelector('.main-cart__wrapper')?.classList.toggle('is-freebie-loading', !!on);
};

// ==========================================
// GIFT RULES — shared by handleGiftProduct and the cart drawer strips
// ==========================================

// What counts towards a gift, in one place (snippets/campaign-free-gift.liquid mirrors it):
//   subtotal / total - every line except free gifts, free bundles and Device/Combo products,
//                      before discounts (subtotal) or after discounts (total), in pounds
//   qty              - every line except free gifts and free bundles
window.getGiftCartTotals = function (cart) {
  let subtotal = cart.original_total_price / 100;
  let total = cart.total_price / 100;
  let qty = 0;
  (cart.items || []).forEach((item) => {
    const isFreebie = item.properties?._gift == 'true' || item.properties?._bundle_gift == 'true';
    const isExcludedType = item.product_type === 'Device' || item.product_type === 'Combo';
    // Subtracted ONCE. These used to be two separate ifs, so a line that was both an excluded
    // product type AND a freebie (a Combo-type free bundle) had its price taken off twice -
    // a GBP64 cart read as GBP14.78 and a comfortably-met gift was removed.
    if (isFreebie || isExcludedType) {
      subtotal -= item.original_line_price / 100;
      total -= item.final_line_price / 100;
    }
    if (!isFreebie) qty += item.quantity;
  });
  return { subtotal, total, qty };
};

// Is a gift config unlocked for these totals?
//   config.mode       'total' | 'qty' | 'both' (AND) | 'either' (OR) - set on campaign gifts.
//                     No mode (Theme-settings gifts): the original rule - the items number
//                     when one is set, otherwise the cart total.
//   config.onSubtotal measure the cart total before discounts; when the config doesn't say,
//                     `defaultOnSubtotal` (the Theme setting) decides.
window.isGiftUnlocked = function (config, totals, defaultOnSubtotal) {
  const threshold = Number(config.threshold || 0);
  const qtyThreshold = Number(config.quantityThreshold || 0);
  const onSubtotal = typeof config.onSubtotal === 'boolean' ? config.onSubtotal : !!defaultOnSubtotal;
  const cartTotal = onSubtotal ? totals.subtotal : totals.total;
  const totalMet = threshold > 0 && cartTotal >= threshold;
  const qtyMet = qtyThreshold > 0 && totals.qty >= qtyThreshold;

  switch (config.mode) {
    case 'total':
      return totalMet;
    case 'qty':
      return qtyMet;
    case 'both':
      return totalMet && qtyMet;
    case 'either':
      return totalMet || qtyMet;
    default:
      if (qtyThreshold > 0) return qtyMet;
      if (threshold > 0) return totalMet;
      return false;
  }
};

// ==========================================
// CART DRAWER — "add the free gift back" strip
// ==========================================
// Shows a thin strip in the drawer for a free gift that was auto-added and then
// MANUALLY removed (so it won't auto-add again) while its threshold is still met.
// Uses the SAME rules as handleGiftProduct (getGiftCartTotals / isGiftUnlocked).

window.updateCartDrawerGiftStrips = async function (cartState) {
  const strips = document.querySelectorAll('#CartDrawer .cd-gift-strip');
  if (!strips.length) return;

  let cart = cartState;
  if (!cart || !cart.items) {
    cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .catch(() => null);
  }
  if (!cart || !cart.items) return;

  const totals = window.getGiftCartTotals(cart);
  const removed = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]');
  const now = Date.now() / 1000;

  let visibleCount = 0;
  strips.forEach((strip) => {
    const variantId = parseInt(strip.getAttribute('data-cd-variant-id'), 10);
    const ends = Number(strip.getAttribute('data-cd-ends')) || 0;
    const config = {
      threshold: parseFloat(strip.getAttribute('data-cd-threshold')) || 0,
      quantityThreshold: parseInt(strip.getAttribute('data-cd-qty-threshold'), 10) || 0,
      mode: strip.getAttribute('data-cd-mode') || undefined,
      onSubtotal: strip.getAttribute('data-cd-subtotal') === 'true',
    };

    // A campaign gift whose campaign has ended is never offered again.
    const met = !(ends > 0 && now >= ends) && window.isGiftUnlocked(config, totals);

    const inCart = cart.items.some(
      (it) =>
        parseInt(it.variant_id, 10) === variantId &&
        it.properties &&
        it.properties._gift === 'true' &&
        it.properties._bundle_gift !== 'true'
    );
    const wasRemoved = removed.indexOf(variantId) !== -1;

    // Show only after a manual removal, while the threshold is still met and it's not in cart.
    const show = met && !inCart && wasRemoved;
    strip.hidden = !show;
    if (show) visibleCount += 1;
  });

  // Show the floating gift button only when there's at least one eligible strip.
  const wrap = document.getElementById('cart-drawer-gift-fab-wrap');
  const cd = document.querySelector('cart-drawer');
  if (wrap) {
    if (visibleCount > 0) {
      wrap.hidden = false;
      const countEl = wrap.querySelector('.cd-gift-fab__count');
      if (countEl) countEl.textContent = visibleCount;
      const fab = document.getElementById('cart-drawer-gift-fab');
      if (fab) fab.setAttribute('aria-expanded', cd && cd.classList.contains('cd-gift-open') ? 'true' : 'false');
    } else {
      // Nothing to offer — hide the button and collapse the panel.
      wrap.hidden = true;
      if (cd) cd.classList.remove('cd-gift-open');
    }
  }
};

// Re-adds a gift the shopper removed. `el` is any element carrying data-cd-variant-id:
// a drawer .cd-gift-strip, or the cart page's campaign .ww-gift-add button.
window.addCartDrawerGift = async function (el) {
  if (!el || !el.getAttribute) return;
  const vid = parseInt(el.getAttribute('data-cd-variant-id'), 10);
  if (!vid) return;

  const isRot = el.getAttribute('data-cd-rot') === 'true';
  const campaign = el.getAttribute('data-cd-campaign') || '';
  const campaignGift = el.getAttribute('data-cd-campaign-gift') || '';

  window.setFreebieLoading?.(true);
  try {
    // Treat it as a normal auto-gift again so it isn't re-hidden / re-removed.
    let removed = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]');
    removed = removed.filter((id) => id !== vid);
    sessionStorage.setItem('removedGiftIds', JSON.stringify(removed));

    // Match the properties each freebie system uses when it auto-adds.
    const properties = isRot
      ? { _gift: 'true', _rotational_freebie: 'true', _rotational_period: campaign, _gift_uid: Date.now().toString() }
      : { _gift: 'true', _auto: 'true', _d_gift: false, _gift_uid: Date.now().toString() };
    if (!isRot && campaignGift) properties._campaign_gift = campaignGift;

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: properties }),
    });
    await new Promise((r) => setTimeout(r, 300));
    // Presence-based: the cart page has <cart-items>, everywhere else uses the drawer.
    if (document.querySelector('cart-items')) {
      await window.refreshCart?.();
    } else {
      await window.refreshCartDrawer?.();
    }
  } catch (e) {
    console.error('[Gift] strip add failed', e);
  } finally {
    window.setFreebieLoading?.(false);
  }
};

// Delegated clicks (survive drawer re-renders).
document.addEventListener('click', function (e) {
  // Add-back buttons: drawer strip, or the cart page's campaign gift button
  const btn = e.target.closest('.cd-gift-strip__add, .ww-gift-add');
  if (btn) {
    e.preventDefault();
    window.addCartDrawerGift(btn.closest('[data-cd-variant-id]'));
    return;
  }

  // Floating gift button — toggle the strips panel (state on <cart-drawer> so it
  // persists across re-renders, like the other drawer panels).
  const fab = e.target.closest('#cart-drawer-gift-fab');
  if (fab) {
    e.preventDefault();
    const cd = fab.closest('cart-drawer');
    if (cd) {
      const open = cd.classList.toggle('cd-gift-open');
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return;
  }

  // Click outside an open panel closes it.
  const cdOpen = document.querySelector('cart-drawer.cd-gift-open');
  if (cdOpen && !e.target.closest('#cart-drawer-gift-fab-wrap')) {
    cdOpen.classList.remove('cd-gift-open');
    const openFab = document.getElementById('cart-drawer-gift-fab');
    if (openFab) openFab.setAttribute('aria-expanded', 'false');
  }
});

// ==========================================
// READ CONFIGS FROM DOM
// ==========================================

// The gift config element. The cart page renders the visible strip (#free-gift-bar), the
// cart drawer a hidden data-only element (#free-gift-data). Either one comes from a live
// campaign (data-gift-source="campaign", snippets/campaign-free-gift.liquid) or from
// Theme settings > Free gift. Null when no gifts are set up anywhere.
function getGiftDataEl() {
  return document.getElementById('free-gift-bar') || document.getElementById('free-gift-data');
}

function readGiftConfigs() {
  const giftBar = getGiftDataEl();
  if (!giftBar) return [];
  try {
    const now = Date.now() / 1000;
    // A campaign gift carries its campaign's end (unix seconds). Drop it once that has
    // passed, so a cached page can't keep adding it - the clean-up below then removes it.
    return JSON.parse(giftBar.dataset.giftConfigs || '[]').filter(
      (c) => !(Number(c.ends) > 0 && now >= Number(c.ends))
    );
  } catch (e) {
    console.error('[Gift] Failed to parse configs', e);
    return [];
  }

}

// ==========================================
// HANDLE GIFTS
// ==========================================

window.handleGiftProduct = async function (cartState) {

  // Prevent multiple simultaneous calls
  if (window.isGiftProductUpdating) return;
  // Prevent duplicate add/remove operations
  if (window._giftAddInProgress) return;
  window.isGiftProductUpdating = true;

  try {

    // ==========================================
    // VALIDATE CART
    // ==========================================

    if (!cartState || !cartState.items) return;
    const giftEl = getGiftDataEl();
    const giftConfigs = readGiftConfigs();
    const isCampaign = giftEl?.dataset.giftSource === 'campaign';
    let themeGiftIds = [];
    try {
      themeGiftIds = JSON.parse(giftEl?.dataset.themeGiftIds || '[]').map((id) => parseInt(id));
    } catch (e) {}
    const removedGiftIds = JSON.parse(
      sessionStorage.getItem('removedGiftIds') || '[]'
    );

    // ==========================================
    // GET FRESH CART (single source of truth)
    // ==========================================

    // The sequential cartUpdate subscriber re-reads a fresh cart between handlers, so the
    // cart handed in is already current — reuse it instead of another /cart.js round-trip.
    // Fall back to a fetch only if a direct caller passed nothing usable.
    const freshCart = (cartState && cartState.items)
      ? cartState
      : await fetch('/cart.js').then((r) => r.json());

    // ==========================================
    // CALCULATE CART VALUES (from freshCart, NOT the passed-in cartState)
    // ==========================================

    // Same element the configs came from, on the cart page and in the drawer alike.
    const defaultOnSubtotal = giftEl?.dataset.freebieOnSubtotal === 'true';
    const totals = window.getGiftCartTotals(freshCart);
    const liveVariantIds = giftConfigs.map((c) => parseInt(c.variantId)).filter(Boolean);

    // ==========================================
    // TRACK IF CART CHANGED
    // ==========================================

    let cartChanged = false;

    const removeGiftLine = async (lineKey) => {
      window._giftAddInProgress = true;
      window.setFreebieLoading(true);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });
      cartChanged = true;
    };

    // ==========================================
    // CLEAN UP GIFTS THAT ARE NO LONGER OFFERED
    // ==========================================
    // - a campaign gift (_campaign_gift) whose campaign has ended or no longer lists it
    // - a Theme-settings gift while a live campaign's gifts are replacing them
    // Gifts that are still offered are left to the threshold loop below.

    for (const item of freshCart.items) {
      const props = item.properties || {};
      if (props._gift !== 'true' || props._bundle_gift === 'true') continue;
      const variantId = parseInt(item.variant_id);
      if (liveVariantIds.includes(variantId)) continue;

      const endedCampaignGift = !!props._campaign_gift;
      const replacedThemeGift =
        isCampaign &&
        props._auto === 'true' &&
        props._vibration !== 'true' &&
        props._rotational_freebie !== 'true' &&
        themeGiftIds.includes(variantId);

      if (endedCampaignGift || replacedThemeGift) {
        await removeGiftLine(item.key);
      }
    }

    // ==========================================
    // LOOP ALL GIFT CONFIGS
    // ==========================================

    for (const config of giftConfigs) {
      const variantId = parseInt(config.variantId);

      if (!variantId) continue;

      // ==========================================
      // CHECK IF THRESHOLD MET (cart total, items, or both - see isGiftUnlocked)
      // ==========================================

      const thresholdMet = window.isGiftUnlocked(config, totals, defaultOnSubtotal);
      const wasManuallyRemoved = removedGiftIds.includes(variantId);

      // ==========================================
      // CHECK IF GIFT EXISTS
      // ==========================================

      // For the ADD decision, only an AUTO-added gift counts as "already present".
      // Bundle lines are excluded throughout: they carry _gift and _auto as well, so if a
      // bundle product shares a variant with a configured gift, this gift would look
      // already-present (never added) and the removal below would delete the bundle.
      const existingGift = freshCart.items.find(
        item =>
          parseInt(item.variant_id) === variantId &&
          item.properties?._gift === 'true' &&
          item.properties?._auto === 'true' &&
          item.properties?._bundle_gift !== 'true'
      );

      // For REMOVAL, match ANY gift line for this variant (don't require _auto), so the
      // gift is reliably removed the moment its threshold drops — in every case.
      const removableGift = freshCart.items.find(
        item =>
          parseInt(item.variant_id) === variantId &&
          item.properties?._gift === 'true' &&
          item.properties?._bundle_gift !== 'true'
      );

      // ==========================================
      // ADD GIFT
      // ==========================================

      if (wasManuallyRemoved) {
        const freebieAtc = document.querySelectorAll('.free-gift-addtocart');
        freebieAtc?.forEach((each) => each.classList.remove('hidden'));
      }

      if (thresholdMet && !existingGift && !wasManuallyRemoved) {
        window._giftAddInProgress = true;
        window.setFreebieLoading(true);

        const properties = {
          _gift: 'true',
          _auto: 'true',
          _d_gift: false,
          _gift_uid: Date.now().toString()
        };
        // Campaign gifts are tagged with their campaign, so they can be cleaned up when it ends.
        if (config.campaign) properties._campaign_gift = config.campaign;

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: properties
          })
        });

        cartChanged = true;

      }

      // ==========================================
      // REMOVE GIFT
      // ==========================================

      if (!thresholdMet && removableGift) {
        await removeGiftLine(removableGift.key);
      }

    }

    // ==========================================
    // REFRESH CART ONLY IF CHANGED
    // ==========================================

    if (cartChanged) {
      // Tells the cartUpdate chain its cart is now stale so it re-reads before the next handler - set on cartChanged rather than at each POST because this is the same condition the handler already trusts to decide it needs a refresh at all.
      window._freebieCartDirty = true;
      // Brief settle for Shopify cart sync (the add/change POST already returned, so a
      // short wait is enough — keeps the freebie appearing quickly).
      await new Promise(resolve => setTimeout(resolve, 120));

      // Presence-based, not pathname-based: the cart page has <cart-items>, the drawer
      // has <cart-drawer>. Matching on '/cart' broke with trailing slashes / locale
      // prefixes (e.g. /en-gb/cart), which sent the refresh to a no-op path so the
      // freebie never appeared even though it was added.
      if (document.querySelector('cart-items')) {
        await window.refreshCart?.();
      } else {
        await window.refreshCartDrawer?.();
      }
    }

  } catch (e) {
    console.error('[Gift] Error:', e);
  } finally {

    // ==========================================
    // RELEASE LOCKS
    // ==========================================

    setTimeout(() => {
      window._giftAddInProgress = false;
      window.isGiftProductUpdating = false;
    }, 500);

  }

  setTimeout(()=>{
    document.body.classList.remove('cart-updating');
  },1000)

};

// --- End gift logic  ---//



//---adding free product for vibration plate ---//


const TRIGGER_VARIANT_ID = 45019782938821;
const AUTO_VARIANT_ID = 45019838939333;

window.isAutoProductUpdating = false;
window._autoAddInProgress = false;

window.handleAutoProduct = async function (cartState) {
  // Prevent overlapping runs
  if (window.isAutoProductUpdating || window._autoAddInProgress) return;
  if (!cartState?.items?.length) return;

  // Controlled by theme setting:
  // Theme settings > Vibration Plate Free Product > Enable Vibration Plate Free Product
  const enabled = window.enableVibrationFreebie === true;

  // Inspect current cart
  let hasTrigger = false;
  let existingFree = null;

  cartState.items.forEach(item => {
    const variantId = Number(item.variant_id);
    if (variantId === TRIGGER_VARIANT_ID) hasTrigger = true;

    const isVibrationGift =
      variantId === AUTO_VARIANT_ID &&
      item.properties?._gift === 'true' &&
      item.properties?._vibration === 'true';

    if (isVibrationGift) existingFree = item;
  });

  // Decide action:
  // - Add the free product only when the feature is enabled and the trigger is present.
  // - Remove an existing free product when disabled OR the trigger is gone (cleanup).
  const shouldAdd = enabled && hasTrigger && !existingFree;
  const shouldRemove = existingFree && (!enabled || !hasTrigger);

  if (!shouldAdd && !shouldRemove) return;

  // Past the guard above this function ALWAYS posts, so the chain's cart is stale from here on - this handler has no cartChanged flag of its own, the early return above is its equivalent.
  window._freebieCartDirty = true;

  window.isAutoProductUpdating = true;
  window.setFreebieLoading(true);

  try {
    if (shouldAdd) {
      window._autoAddInProgress = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: AUTO_VARIANT_ID,
          quantity: 1,
          properties: {
            _gift: 'true',
            _auto: 'true',
            _vibration: 'true',
            _gift_uid: Date.now().toString()
          }
        })
      });
    } else if (shouldRemove) {
      window._autoAddInProgress = true;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: existingFree.key,
          quantity: 0
        })
      });
    }

    // Small delay for Shopify cart sync, then refresh the UI
    await new Promise(resolve => setTimeout(resolve, 300));

    // Presence-based refresh — see note above (handles /cart, /en-gb/cart, etc.).
    if (document.querySelector('cart-items')) {
      await window.refreshCart?.();
    } else {
      await window.refreshCartDrawer?.();
    }

  } catch (e) {
    console.error('handleAutoProduct error:', e);
  } finally {
    setTimeout(() => {
      window._autoAddInProgress = false;
      window.isAutoProductUpdating = false;
    }, 500);
  }
};

function releaseAutoLock() {
  setTimeout(() => {
    window.isAutoProductUpdating = false;
  }, 400); // 300–500ms is safe
}

window.syncAutoProductWithCart = function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      window.handleAutoProduct(cart);
      window.handleGiftProduct(cart);
    });
};

document.addEventListener('DOMContentLoaded', function () {
  window.syncAutoProductWithCart();
  // Evaluate the drawer "add the free gift back" strip on load. The inline drawer
  // script can't do this (it runs before this deferred file defines the function),
  // which is why a manually-removed gift's strip didn't show after a page refresh.
  window.updateCartDrawerGiftStrips && window.updateCartDrawerGiftStrips();
});

// ==========================================
// ROTATING FREE GIFT LOGIC (single active product, inventory-based rotation)
// Independent of the existing handleGiftProduct system. Reads #rotating-gift-bar.
// ==========================================

window.isRotatingGiftUpdating = false;
window._rotGiftInProgress = false;

function readRotatingGiftConfig() {
  // Cart page renders the visible strip (#rotating-gift-bar); the cart drawer
  // renders a hidden data-only element (#rotating-gift-data). Either provides config.
  const bar = document.getElementById('rotating-gift-bar') || document.getElementById('rotating-gift-data');
  if (!bar) return null;
  try {
    const configs = JSON.parse(bar.dataset.rotGiftConfigs || '[]');
    return {
      active: configs[0] || null,
      freebieOnSubtotal: bar.dataset.freebieOnSubtotal === 'true',
      campaignId: bar.dataset.rotCampaignId || ''
    };
  } catch (e) {
    console.error('[RotGift] Failed to parse configs', e);
    return null;
  }
}

window.handleRotatingGift = async function (cartState) {
  if (window.isRotatingGiftUpdating || window._rotGiftInProgress) return;
  window.isRotatingGiftUpdating = true;

  try {
    if (!cartState || !cartState.items) return;

    const cfg = readRotatingGiftConfig();
    if (!cfg) return; // feature disabled / bar not rendered

    const removedGiftIds = JSON.parse(sessionStorage.getItem('removedGiftIds') || '[]');

    // Liquid already picked the single active product via inventory rotation.
    const active = cfg.active;
    const activeVariantId = active ? parseInt(active.variantId) : 0;
    const threshold = Number(active?.threshold || 0);

    // ==========================================
    // CALCULATE ELIGIBLE CART TOTAL (mirror Liquid: exclude Device/Combo + gifts)
    // ==========================================
    let totalPrice = cfg.freebieOnSubtotal
      ? cartState.original_total_price / 100
      : cartState.total_price / 100;

    cartState.items.forEach(item => {
      // Subtract once only - see the note in handleGiftProduct. A Combo-type free bundle
      // matched both rules and was deducted twice.
      const isExcludedType = item.product_type === 'Device' || item.product_type === 'Combo';
      const isFreebie =
        item.properties?._gift === 'true' || item.properties?._bundle_gift === 'true';
      if (isExcludedType || isFreebie) {
        totalPrice -= item.final_line_price / 100;
      }
    });

    const thresholdMet = threshold > 0 ? totalPrice >= threshold : true;

    // Use the cart handed in (fresh from the cartUpdate/add response) instead of an extra
    // /cart.js round-trip. After any removal below we still re-read for an accurate add check.
    const freshCart = cartState;

    let cartChanged = false;

    // ==========================================
    // 1. ENFORCE SINGLE ACTIVE: remove any rotating gift that isn't the active product
    //    (handles rotation switch 1 -> 2 -> ... and unlock loss)
    // ==========================================
    for (const item of freshCart.items) {
      const isRotGift = item.properties?._gift === 'true' && item.properties?._rotational_freebie === 'true';
      if (!isRotGift) continue;

      // Only enforce single-active when Liquid actually resolved an active product.
      // rot_gift_configs_json comes through empty whenever no candidate qualifies (out of
      // stock, cart_status Disabled, or the per-campaign sell limit reached). readRotating-
      // GiftConfig then yields active: null, so activeVariantId is 0 and threshold is 0 -
      // and because thresholdMet falls back to true when threshold is 0, it reads TRUE. Every
      // rotating gift in the cart then failed the isActive check and was silently deleted,
      // even with its threshold comfortably met and the rewards bar still showing unlocked.
      // With no active product there is nothing to enforce against, so leave the cart alone.
      if (!activeVariantId) continue;

      const isActive = parseInt(item.variant_id) === activeVariantId;
      if (!isActive || !thresholdMet) {
        window._rotGiftInProgress = true;
        window.setFreebieLoading(true);
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        cartChanged = true;
      }
    }

    // Re-read after removals so the add check is accurate
    let currentItems = freshCart.items;
    if (cartChanged) {
      currentItems = (await fetch('/cart.js').then(res => res.json())).items;
    }

    // ==========================================
    // 2. ADD active gift when unlocked, not already present, not manually removed
    // ==========================================
    const wasManuallyRemoved = removedGiftIds.includes(activeVariantId);
    if (wasManuallyRemoved) {
      const freebieAtc = document.querySelectorAll('.rot_free-gift-addtocart');
      freebieAtc?.forEach((each) => each.classList.remove('hidden'));
    }

    const alreadyInCart = currentItems.some(
      item => parseInt(item.variant_id) === activeVariantId &&
              item.properties?._gift === 'true' &&
              item.properties?._rotational_freebie === 'true'
    );

    if (activeVariantId && thresholdMet && !alreadyInCart && !wasManuallyRemoved) {
      window._rotGiftInProgress = true;
      window.setFreebieLoading(true);
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: activeVariantId,
          quantity: 1,
          properties: {
            _gift: 'true',
            _rotational_freebie: 'true',
            _rotational_period: cfg.campaignId,
            _gift_uid: Date.now().toString()
          }
        })
      });
      cartChanged = true;
    }

    // ==========================================
    // 3. REFRESH ONLY IF CHANGED
    // ==========================================
    if (cartChanged) {
      // Marks the chain's cart stale — see the matching note in handleGiftProduct.
      window._freebieCartDirty = true;
      // Brief settle for Shopify cart sync (POST already returned).
      await new Promise(resolve => setTimeout(resolve, 120));
      // Presence-based refresh — see note above (handles /cart, /en-gb/cart, etc.).
      if (document.querySelector('cart-items')) {
        await window.refreshCart?.();
      } else {
        await window.refreshCartDrawer?.();
      }
    }
  } catch (e) {
    console.error('[RotGift] Error:', e);
  } finally {
    setTimeout(() => {
      window._rotGiftInProgress = false;
      window.isRotatingGiftUpdating = false;
    }, 500);
    setTimeout(()=>{
      document.body.classList.remove('cart-updating');
    },1000)
  }
};

// Hook into cart updates without touching existing handlers (uses the same pub/sub
// that cart.js already publishes on every quantity/line change).
//
// The loader is NOT shown for plain cart changes — only the freebie handlers show it
// (via setFreebieLoading) when they actually add/remove a gift, and their refresh
// hides it again.
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    // Reuse the fresh cart the event already carries (the add/quantity/remove response)
    // instead of an extra /cart.js round-trip, so the freebie check starts immediately.
    // Fall back to a fetch only if the event didn't include cart data.
    const ready = event && event.cartData && event.cartData.items
      ? Promise.resolve(event.cartData)
      : fetch('/cart.js').then((res) => res.json());
    ready
      .then(async (cart) => {
        // Run the handlers SEQUENTIALLY (not in parallel) and re-read the cart between
        // them, so each handler sees the previous one's add/remove. Running in parallel
        // (or on the same stale cart) made their refreshes race and could leave one gift
        // still showing even though the server removed it — it only caught up on the next
        // cart change. Awaiting each with a fresh cart makes every removal land together.
        // Re-reads the cart ONLY when the handler that just ran actually posted a change - it used to fetch unconditionally between every handler, spending three round trips re-reading an untouched cart on the common path where a plain quantity change moves no freebie at all.
        const refetch = async (fallback) => {
          if (!window._freebieCartDirty) return fallback;
          window._freebieCartDirty = false;
          try {
            return await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          } catch (e) {
            return fallback;
          }
        };
        // The cart above is the add/quantity/remove response, so it is current as the chain starts.
        window._freebieCartDirty = false;
        await window.handleRotatingGift?.(cart);
        const cart2 = await refetch(cart);
        await window.handleGiftProduct?.(cart2);
        const cart3 = await refetch(cart2);
        await window.handleAutoProduct?.(cart3);
        // The free bundle runs LAST, in this same chain, for the reason above: it adds a
        // _gift line of its own, and the handlers before it subtract _gift lines from the
        // totals their thresholds are measured against. Run concurrently, its add landed
        // mid-sequence and could push a gift under its threshold, removing a freebie that
        // should have stayed.
        const cart4 = await refetch(cart3);
        // inChain: the handlers above have finished, so the bundle may mutate here. Their
        // locks are released on a 500ms timer, so they still read as busy at this point -
        // without this flag the bundle would be blocked and would fall through to some
        // later, uncontrolled moment, which is the interleaving this ordering prevents.
        await window.syncCartDrawerBundle?.(cart4, true);
      })
      .catch(err => console.error('[Freebie] cartUpdate handling failed:', err))
      .finally(() => {
        // Safety net: if a freebie op showed the loader, its refresh already hid it —
        // this just guarantees it can never get stuck on.
        window.setFreebieLoading?.(false);
        // Re-evaluate the drawer "add the free gift back" strip against the fresh cart.
        window.updateCartDrawerGiftStrips?.();
      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (!document.getElementById('rotating-gift-bar') && !document.getElementById('rotating-gift-data')) return;
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => window.handleRotatingGift(cart))
    .catch(err => console.error('[RotGift] init fetch failed:', err));
});
// ==========================================
// RECALCULATE THE CART AFTER A LOGIN / LOGOUT
// ==========================================
// Shopify re-evaluates cart-level automatic discounts when the cart is WRITTEN, not when a
// customer signs in. So a cart built while logged out keeps its guest prices after login
// until something touches it — which is why a customer-only discount only appeared once the
// shopper nudged a quantity. Re-rendering cannot fix that: the stored cart genuinely still
// holds the old prices.
//
// So: remember which customer the cart was last written for, and when that changes, write
// the cart once to force the recalculation. The write re-saves the existing note, so it
// changes nothing a customer or the merchant can see.
window.recalcCartForCustomerChange = function () {
  const KEY = 'wwCartCustomerId';
  const current = String(window.wwCustomerId || 0);

  let last = null;
  try {
    last = localStorage.getItem(KEY);
    localStorage.setItem(KEY, current);
  } catch (e) {
    return Promise.resolve(); // private mode etc. — skip rather than write on every load
  }

  // Unchanged, or a first visit with nothing to compare against.
  if (last === null || last === current) return Promise.resolve();

  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      if (!cart || !cart.item_count) return null; // empty cart, nothing to recalculate
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: cart.note || '' }),
      });
    })
    .then((res) => {
      if (!res) return;
      // Re-render whichever cart UI is on the page so the new prices show immediately.
      if (document.querySelector('cart-items')) return window.refreshCart?.();
      return window.refreshCartDrawer?.();
    })
    .catch((e) => console.error('[Cart] customer-change recalculation failed', e));
};

document.addEventListener('DOMContentLoaded', function () {
  window.recalcCartForCustomerChange();
});
